import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlueprintContentPage, LazyBlueprintPage, LazyComponentBackgroundImageWithOverlayImage, LazyComponentBenefits, LazyComponentBrandB2c, LazyComponentCatalogue, LazyComponentCategoriesQuicksearch, LazyComponentCategoryProductLines, LazyComponentContactPerson, LazyComponentExclusiveBrandB2b, LazyComponentExclusiveBrandB2c, LazyComponentExclusiveShopB2b, LazyComponentFullscreenImageWithText, LazyComponentFullscreenSlider, LazyComponentImageGallery, LazyComponentImageWithText, LazyComponentImages, LazyComponentLocations, LazyComponentOverlappingImageWithText, LazyComponentOverlappingTextWithImage, LazyComponentOverlayTransparentImages, LazyComponentProductListing, LazyComponentServices, LazyComponentTeam, LazyComponentTeamSlider, LazyComponentTeaserBrands, LazyComponentTeaserCategorySmall, LazyComponentTeaserExclusiveBrands, LazyComponentTeaserImageVideo, LazyComponentTeaserImageVideoWithImageBackground, LazyComponentTeaserProductLine, LazyComponentTeaserProductsLarge, LazyComponentTeaserProductsSmall, LazyComponentText, LazyComponentTilesWithTextAndImage, LazyComponentTopicsGallery, LazyComponentVideo, LazyIconAngleDown, LazyIconAngleLeft, LazyIconAngleRight, LazyIconAngleUp, LazyIconArrowLeft, LazyIconArrowRight, LazyIconCart, LazyIconCheck, LazyIconClose, LazyIconCreditCard, LazyIconDiamond, LazyIconDocument, LazyIconDownload, LazyIconEdit, LazyIconEmail, LazyIconEnvelope, LazyIconExcel, LazyIconEye, LazyIconFile, LazyIconFolder, LazyIconHamburger, LazyIconHand, LazyIconHeart, LazyIconImage, LazyIconInfo, LazyIconLoading, LazyIconLocation, LazyIconLock, LazyIconLogout, LazyIconMail, LazyIconMessage, LazyIconMinus, LazyIconPackage, LazyIconPaymentAmericanExpress, LazyIconPaymentApplePay, LazyIconPaymentCoupon, LazyIconPaymentGPay, LazyIconPaymentMastercard, LazyIconPaymentPostFinance, LazyIconPaymentRechnung, LazyIconPaymentTwint, LazyIconPaymentVisa, LazyIconPdf, LazyIconPercent, LazyIconPhone, LazyIconPlus, LazyIconQuestionMark, LazyIconSearch, LazyIconShoppingBag, LazyIconSignOut, LazyIconTrash, LazyIconUnlock, LazyIconUser, LazyIconWord, LazyIconX, LazyIconZip } from '#components'
const lazyGlobalComponents = [
  ["BlueprintContentPage", LazyBlueprintContentPage],
["BlueprintPage", LazyBlueprintPage],
["ComponentBackgroundImageWithOverlayImage", LazyComponentBackgroundImageWithOverlayImage],
["ComponentBenefits", LazyComponentBenefits],
["ComponentBrandB2c", LazyComponentBrandB2c],
["ComponentCatalogue", LazyComponentCatalogue],
["ComponentCategoriesQuicksearch", LazyComponentCategoriesQuicksearch],
["ComponentCategoryProductLines", LazyComponentCategoryProductLines],
["ComponentContactPerson", LazyComponentContactPerson],
["ComponentExclusiveBrandB2b", LazyComponentExclusiveBrandB2b],
["ComponentExclusiveBrandB2c", LazyComponentExclusiveBrandB2c],
["ComponentExclusiveShopB2b", LazyComponentExclusiveShopB2b],
["ComponentFullscreenImageWithText", LazyComponentFullscreenImageWithText],
["ComponentFullscreenSlider", LazyComponentFullscreenSlider],
["ComponentImageGallery", LazyComponentImageGallery],
["ComponentImageWithText", LazyComponentImageWithText],
["ComponentImages", LazyComponentImages],
["ComponentLocations", LazyComponentLocations],
["ComponentOverlappingImageWithText", LazyComponentOverlappingImageWithText],
["ComponentOverlappingTextWithImage", LazyComponentOverlappingTextWithImage],
["ComponentOverlayTransparentImages", LazyComponentOverlayTransparentImages],
["ComponentProductListing", LazyComponentProductListing],
["ComponentServices", LazyComponentServices],
["ComponentTeam", LazyComponentTeam],
["ComponentTeamSlider", LazyComponentTeamSlider],
["ComponentTeaserBrands", LazyComponentTeaserBrands],
["ComponentTeaserCategorySmall", LazyComponentTeaserCategorySmall],
["ComponentTeaserExclusiveBrands", LazyComponentTeaserExclusiveBrands],
["ComponentTeaserImageVideo", LazyComponentTeaserImageVideo],
["ComponentTeaserImageVideoWithImageBackground", LazyComponentTeaserImageVideoWithImageBackground],
["ComponentTeaserProductLine", LazyComponentTeaserProductLine],
["ComponentTeaserProductsLarge", LazyComponentTeaserProductsLarge],
["ComponentTeaserProductsSmall", LazyComponentTeaserProductsSmall],
["ComponentText", LazyComponentText],
["ComponentTilesWithTextAndImage", LazyComponentTilesWithTextAndImage],
["ComponentTopicsGallery", LazyComponentTopicsGallery],
["ComponentVideo", LazyComponentVideo],
["IconAngleDown", LazyIconAngleDown],
["IconAngleLeft", LazyIconAngleLeft],
["IconAngleRight", LazyIconAngleRight],
["IconAngleUp", LazyIconAngleUp],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRight", LazyIconArrowRight],
["IconCart", LazyIconCart],
["IconCheck", LazyIconCheck],
["IconClose", LazyIconClose],
["IconCreditCard", LazyIconCreditCard],
["IconDiamond", LazyIconDiamond],
["IconDocument", LazyIconDocument],
["IconDownload", LazyIconDownload],
["IconEdit", LazyIconEdit],
["IconEmail", LazyIconEmail],
["IconEnvelope", LazyIconEnvelope],
["IconExcel", LazyIconExcel],
["IconEye", LazyIconEye],
["IconFile", LazyIconFile],
["IconFolder", LazyIconFolder],
["IconHamburger", LazyIconHamburger],
["IconHand", LazyIconHand],
["IconHeart", LazyIconHeart],
["IconImage", LazyIconImage],
["IconInfo", LazyIconInfo],
["IconLoading", LazyIconLoading],
["IconLocation", LazyIconLocation],
["IconLock", LazyIconLock],
["IconLogout", LazyIconLogout],
["IconMail", LazyIconMail],
["IconMessage", LazyIconMessage],
["IconMinus", LazyIconMinus],
["IconPackage", LazyIconPackage],
["IconPaymentAmericanExpress", LazyIconPaymentAmericanExpress],
["IconPaymentApplePay", LazyIconPaymentApplePay],
["IconPaymentCoupon", LazyIconPaymentCoupon],
["IconPaymentGPay", LazyIconPaymentGPay],
["IconPaymentMastercard", LazyIconPaymentMastercard],
["IconPaymentPostFinance", LazyIconPaymentPostFinance],
["IconPaymentRechnung", LazyIconPaymentRechnung],
["IconPaymentTwint", LazyIconPaymentTwint],
["IconPaymentVisa", LazyIconPaymentVisa],
["IconPdf", LazyIconPdf],
["IconPercent", LazyIconPercent],
["IconPhone", LazyIconPhone],
["IconPlus", LazyIconPlus],
["IconQuestionMark", LazyIconQuestionMark],
["IconSearch", LazyIconSearch],
["IconShoppingBag", LazyIconShoppingBag],
["IconSignOut", LazyIconSignOut],
["IconTrash", LazyIconTrash],
["IconUnlock", LazyIconUnlock],
["IconUser", LazyIconUser],
["IconWord", LazyIconWord],
["IconX", LazyIconX],
["IconZip", LazyIconZip],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
